import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import { styled } from '../../utils';
import { Card } from '../Card/Card';
import { CardContent } from '../Card/CardContent';
import { DataTableListItem } from './DataTableListItem';
const TableList = styled('div')(() => ({
    overflowY: 'auto',
    // substract height of header
    height: '56.5vh',
}));
export const Separator = styled('div')(({ theme }) => ({
    '&:not(:last-of-type)': {
        borderBottom: `1px solid ${theme.palette.secondary.contrastText}`,
        width: '100%',
        justifyItems: 'center',
        display: 'block',
    },
    display: 'none',
}));
const CardContentStyled = styled(CardContent, {
    shouldForwardProp: (prop) => prop !== 'selected',
})(({ theme, selected }) => ({
    background: selected ? theme.palette.info.main : 'inherit',
}));
export function DataTableList({ rowDataList, selectedItemIndex, setSelectedItemIndex, }) {
    return (_jsx(Card, { children: _jsx(TableList, { children: rowDataList?.map((rowData, index) => (_jsxs(Fragment, { children: [_jsx(CardContentStyled, { selected: selectedItemIndex === index, children: _jsx(DataTableListItem, { headerTitle: rowData.headerTitle, headerTags: rowData.headerTags, contentData: rowData.contentData, handleSelect: () => setSelectedItemIndex(index) }) }), _jsx(Separator, {})] }, `dataTableListItem_${index}`))) }) }));
}
